import Seo from "../components/Seo";
import { PAGE_SEO } from "../seo/site";

const MAP_EMBED_URL = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3808.119890641354!2d78.52401453018085!3d17.35796306119176!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb988cfebf45d7%3A0xb041144a4631ca4!2sP%20%26%20T%20Colony%2C%20Dilsukhnagar%2C%20Hyderabad%2C%20Telangana%20500060!5e0!3m2!1sen!2sin!4v1751460791555!5m2!1sen!2sin";

const CONTACT_CARDS = [
  {
    eyebrow: "Our Address",
    title: "Located in the Heart of Hyderabad",
    body: (
      <>
        <p className="vd-contact-address">
          <strong>Registered Address:</strong><br />
          Propify Realty Networks Pvt Ltd<br />
          #302, P &amp; T Colony, Dilsukhnagar,<br />
          Hyderabad - 500060, Telangana, India
        </p>
        <p className="vd-contact-address">
          <strong>Corporate Office:</strong><br />
          Propify Realty Networks Pvt Ltd<br />
          H, 2-1-279, Street Number 6, Mamatha Nagar Colony, Nagole,<br />
          Hyderabad, Telangana 500068
        </p>
      </>
    )
  },
  {
    eyebrow: "Sales Inquiries",
    title: "Talk to Our Sales Experts",
    text: "Need a Property or Want to List One? Let’s Talk.",
    links: [
      { href: "mailto:support@venturesdirectory.com", label: "support@venturesdirectory.com", kind: "email" },
      { href: "tel:+919618641100", label: "+91 96186 41100", kind: "phone" }
    ]
  },
  {
    eyebrow: "Customer Support",
    title: "Need Help? Contact Support",
    text: "We’re Ready to Assist You with Any Issue or Query.",
    links: [
      { href: "mailto:support@venturesdirectory.com", label: "support@venturesdirectory.com", kind: "email" },
      { href: "tel:+919618641100", label: "+91 96186 41100", kind: "phone" }
    ]
  },
  {
    eyebrow: "Buy, Sell, or Rent",
    title: "Instant Support via WhatsApp",
    text: "Chat with Our Team — Fast, Simple, and Direct",
    links: [
      { href: "https://wa.me/919618641100", label: "+91 96186 41100", kind: "whatsapp" }
    ],
    note: "We’re available to discuss your property needs anytime."
  }
];

function ContactPage() {
  return <main className="vd-page vd-contact-page">
      <Seo {...PAGE_SEO.contact} />
      <section className="vd-page-hero">
        <div className="vd-page-hero-inner">
          <p className="vd-page-kicker">Contact Us</p>
          <h1>Get in Touch with <span>VenturesDirectory</span></h1>
          <p className="vd-page-lead">We’re here to help you Discover Ventures — Anytime.</p>
          <p>
            Connect with our team for sales, support, or property-related inquiries.
            We’re just a call, email, or WhatsApp away.
          </p>
        </div>
      </section>

      <section className="vd-page-section">
        <div className="vd-contact-map">
          <iframe
            title="Propify Realty Networks location map"
            src={MAP_EMBED_URL}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </section>

      <section className="vd-page-section">
        <div className="vd-contact-grid">
          {CONTACT_CARDS.map((card) => <article key={card.eyebrow} className="vd-contact-card">
              <p className="vd-contact-eyebrow">{card.eyebrow}</p>
              <h2>{card.title}</h2>
              {card.text ? <p>{card.text}</p> : null}
              {card.body || null}
              {card.links ? <div className="vd-contact-links">
                  {card.links.map((link) => <a
                    key={link.href}
                    href={link.href}
                    target={link.kind === "whatsapp" ? "_blank" : undefined}
                    rel={link.kind === "whatsapp" ? "noopener noreferrer" : undefined}
                  >
                    {link.kind === "email" ? "Email: " : link.kind === "phone" ? "Call: " : "WhatsApp: "}
                    {link.label}
                  </a>)}
                </div> : null}
              {card.note ? <p className="vd-contact-note">{card.note}</p> : null}
            </article>)}
        </div>
      </section>
    </main>;
}

export default ContactPage;
